import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Payments.css';

function PaymentSuccess() {
  const navigate = useNavigate();

  return (
    <div className="payments-container">
      <div className="payments-card payment-result-card">
        <div className="payments-header">
          <h1>Płatność przyjęta</h1>
          <p>Dziękujemy za dokonanie płatności</p>
        </div>
        <div className="payments-content payment-result-content">
          <div className="payment-status-icon">&#9203;</div>
          <p className="payment-result-text">
            Trwa przetwarzanie płatności. Może to potrwać kilka minut.
          </p>
          <p className="payment-result-subtext">
            Status subskrypcji zostanie zaktualizowany automatycznie po potwierdzeniu płatności.
          </p>
          <div className="payments-action">
            <button className="btn-pay" onClick={() => navigate('/payments')}>
              Wróć do płatności
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
